import AxiosInstance from "../config/axiosInterceptor";
import { statusArr } from "../config/AppConstants";
import { ContentApiRoutes } from "../../navigation/NavConstant";

export const HelperServices = {
  getCountries: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.COUNTRIES, { params }),
  getAllValidCountries: () =>
    AxiosInstance.get(
      ContentApiRoutes.COUNTRIES + "?pagination=0&status=" + statusArr.active
    ),
  getStates: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.STATES, { params }),

  getAllValidStates: (params?: any) => {
    const url =
      ContentApiRoutes.STATES + "?pagination=0&status=" + statusArr.active;
    return AxiosInstance.get(url, {
      params,
      cache: {
        maxAge: 30 * 60 * 1000, // 2 min instead of 15 min
        exclude: { query: false },
      },
    });
  },
  viewArea: (params?: any) => {
    const url = ContentApiRoutes.AREAS + "/" + params;
    return AxiosInstance.get(url);
    // return AxiosInstance.get(url, {
    //   params,
    //   cache: {
    //     maxAge: 30 * 60 * 1000, // 2 min instead of 15 min
    //     exclude: { query: false },
    //   },
    // });
  },
  viewBuilding: (params?: any) => {
    const url = ContentApiRoutes.BUILDINGS + "/" + params;
    return AxiosInstance.get(url);
    // return AxiosInstance.get(url, {
    //   params,
    //   cache: {
    //     maxAge: 30 * 60 * 1000, // 2 min instead of 15 min
    //     exclude: { query: false },
    //   },
    // });
  },

  getCompanyTypes: (params?: any) => {
    const url =
      ContentApiRoutes.COMPANY_TYPES +
      "?pagination=0&status=" +
      statusArr.active;
    return AxiosInstance.get(url, {
      params,
      cache: {
        maxAge: 30 * 60 * 1000, // 2 min instead of 15 min
        exclude: { query: false },
      },
    });
  },
  getProductTypes: (params?: any) => {
    const url =
      ContentApiRoutes.PRODUCT_TYPES +
      "?pagination=0&status=" +
      statusArr.active;
    return AxiosInstance.get(url, {
      params,
      cache: {
        maxAge: 30 * 60 * 1000, // 2 min instead of 15 min
        exclude: { query: false },
      },
    });
  },
  getCreatedByList: (params?: any) => {
    const url = ContentApiRoutes.CREATED_BY_LIST + "?pagination=0";
    return AxiosInstance.get(url, {
      params,
    });
  },
  createState: (params: any) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_STATE, params),
  updateState: (params: any) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_STATE.replace(":id", params.id.toString()) +
        "?_method=PUT",
      params
    ),
  deleteState: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_STATE.replace(":id", id.toString())
    ),
  getCities: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.CITIES, { params }),
  getAllValidCities: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.CITIES + "?pagination=0&status=" + statusArr.active,
      {
        params,
      }
    ),
  createCity: (params: any) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_CITY, params),
  updateCity: (params: any) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_CITY.replace(":id", params.id.toString()) +
        "?_method=PUT",
      params
    ),
  deleteCity: (id: number) =>
    AxiosInstance.delete(
      ContentApiRoutes.DELETE_CITY.replace(":id", id.toString())
    ),
  importArea: (params: any) =>
    AxiosInstance.post(ContentApiRoutes.IMPORT_AREA, params),
  getAreas: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.AREAS, { params }),
  addArea: (params: any) =>
    AxiosInstance.post(ContentApiRoutes.ADD_AREA, params),
  updateArea: (params: any) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_AREA + params.id + "?_method=PUT",
      params
    ),
  deleteArea: (params: any) =>
    AxiosInstance.delete(ContentApiRoutes.DELETE_AREA + params.id),
  getAllValidAreas: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.AREAS + "?pagination=0&status=" + statusArr.active,
      {
        params,
      }
    ),
  getAllAdminThemes: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.AADMIN_THEMES +
        "?pagination=0&sort_by=theme_title&status=" +
        statusArr.active,
      {
        params,
      }
    ),
  importBuildings: (params: any) =>
    AxiosInstance.post(ContentApiRoutes.IMPORT_BUILDINGS, params),
  addBuilding: (params: any) =>
    AxiosInstance.post(ContentApiRoutes.ADD_BUILDING, params),
  updateBuilding: (params: any) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_BUILDING + params.id + "?_method=PUT",
      params
    ),
  deleteBuilding: (params: any) =>
    AxiosInstance.delete(ContentApiRoutes.DELETE_BUILDING + params.id),
  getBuildings: (params?: any) =>
    AxiosInstance.get(ContentApiRoutes.BUILDINGS, { params }),
  getAllValidBuildings: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.BUILDINGS + "?pagination=0&status=" + statusArr.active,
      {
        params,
      }
    ),
  getAllValidLicenses: (params?: any) =>
    AxiosInstance.get(
      ContentApiRoutes.LICENSES + "?pagination=0&status=" + statusArr.active,
      {
        params,
      }
    ),
};
